import {
  CHARGE_BEGIN,
  CHARGE_SUCCESS,
  APPLY_COUPON_STARTED,
  APPLY_COUPON_SUCCESS,
  SET_REMOVE_COUPON,
  CHARGE_FAILURE,
  FETCH_UPGRADE_PLAN_INVOICE_STARTED,
  FETCH_UPGRADE_PLAN_INVOICE_SUCCESS,
  FETCH_UPGRADE_PLAN_INVOICE_BEGIN,
  UPGRADE_PLAN_STARTED,
  UPGRADE_PLAN_SUCCESS,
} from "../actionTypeConstants/constants";

const initialState = {
  charge_success: false,
  isChargeStarted: false,
  isApplyCouponStarted: false,
  isCouponApplied: false,
  couponDetails: {},
  isFetchUpgradePlanInvoiceStarted: false,
  isFetchUpgradePlanInvoiceFetched: false,
  isUpgradePlanStarted: false,
  isUpgradePlanDone: false,
  upgradedPlanInvoice: {},
};
export default (state = initialState, action) => {
  switch (action.type) {
    case APPLY_COUPON_STARTED:
      return { ...state, isApplyCouponStarted: action.payload.status };
    case APPLY_COUPON_SUCCESS: {
      const {
        total_discounted_amount,
        total_discounted_amount_formatted,
        coupon,
      } = action.payload.data;
      return {
        ...state,
        isApplyCouponStarted: action.payload.status,
        isCouponApplied: true,
        couponDetails: {
          coupon,
          total_discounted_amount,
          total_discounted_amount_formatted,
        },
      };
    }
    case SET_REMOVE_COUPON:
      return { ...state,
        isApplyCouponStarted: false,
        isCouponApplied: false,
        couponDetails : {}
       };
    case CHARGE_BEGIN:
      return { ...state, isChargeStarted: true };
    case CHARGE_SUCCESS:
      return {
        ...state,
        isChargeStarted: false,
        charge_success: action.payload.status,
        isCouponApplied: false,
        couponDetails: {},
      };
    case CHARGE_FAILURE:
      return { ...state, isChargeStarted: false };

    case FETCH_UPGRADE_PLAN_INVOICE_STARTED:
      return {
        ...state,
        isFetchUpgradePlanInvoiceStarted: action.payload.status,
      };
    case FETCH_UPGRADE_PLAN_INVOICE_BEGIN:
      return {
        ...state,
        isFetchUpgradePlanInvoiceFetched: action.payload.status,
      };
    case FETCH_UPGRADE_PLAN_INVOICE_SUCCESS: {
      return {
        ...state,
        isUpgradePlanDone: false,
        isFetchUpgradePlanInvoiceStarted: action.payload.status,
        isFetchUpgradePlanInvoiceFetched: true,
        upgradedPlanInvoice: action.payload.data,
      };
    }
    case UPGRADE_PLAN_STARTED:
      return {
        ...state,
        isUpgradePlanStarted: action.payload.status,
      };
    case UPGRADE_PLAN_SUCCESS:
      return {
        ...state,
        isUpgradePlanDone: action.payload.data,
        isApplyCouponStarted: false,
        isCouponApplied: false,
        couponDetails : {}
      };
    default:
      return state;
  }
};
